import { Routes } from '@angular/router';
import { AppLayout } from './core/layout/component/app.layout';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { ReinitialiserComponent } from './pages/auth/reinitialiser/reinitialiser.component';
import { SigninComponent } from './pages/auth/signin/signin.component';
import { ValidateComponent } from './pages/auth/validate/validate.component';
import { QuotesPreviewComponent } from './pages/quotes/quotes-preview/quotes-preview.component';
import { InvoicesPreviewComponent } from './pages/invoices/invoices-preview/invoices-preview.component';
import { AdminGuard } from './core/services/guard.service';
import { permissionGuard } from './core/guards/permission.guard';
import { PERM } from './core/constants/app-permissions';
import { WelcomeWizardComponent } from './core/components/welcome-wizard/welcome-wizard.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: SigninComponent,
    data: {
      renderMode: 'server'
    }
  },
  {
    path: 'bienvenue',
    component: WelcomeWizardComponent,
    canActivate: [AdminGuard],
    data: { renderMode: 'server' }
  },
  {
    path: 'acces-refuse',
    canActivate: [AdminGuard],
    loadComponent: () => import('./pages/access-denied/access-denied.component').then(m => m.AccessDeniedComponent),
    data: { renderMode: 'server' }
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: {
      renderMode: 'server'
    }
  },
  {
    path: 'reinitialiser/:token',
    component: ReinitialiserComponent,
    data: {
      renderMode: 'server'
    }
  },
  {
    path: 'validate/:token',
    component: ValidateComponent,
    data: {
      renderMode: 'server'
    }
  },
  {
    path: 'join/:token',
    loadComponent: () => import('./pages/join/join.component').then(m => m.JoinComponent),
    data: { renderMode: 'server' }
  },
  {
    path: 'devis/:uuid',
    component: QuotesPreviewComponent,
    data: {
      renderMode: 'server'
    }
  },
  {
    path: 'factures/:uuid',
    component: InvoicesPreviewComponent,
    data: {
      renderMode: 'server'
    }
  },
  {
    path: 'custom',
    canActivate: [AdminGuard],
    loadChildren: () => import('./custom/route').then(m => m.CUSTOM_ROUTES)
  },
  {
    path: 'moni',
    component: AppLayout,
    canActivate: [AdminGuard, permissionGuard],
    data: { permissions: [PERM.accessMoni], permissionMode: 'any' },
    loadChildren: () => import('./pages/route').then(m => m.PAGES_ROUTES)
  },
  {
    path: 'pos',
    canActivate: [AdminGuard, permissionGuard],
    data: { permissions: [PERM.createOrders, PERM.viewOrders], permissionMode: 'any' },
    loadChildren: () => import('./pages/pos/pos.routes').then(m => m.POS_ROUTES)
  },
  {
    path: 'skedi',
    canActivate: [AdminGuard],
    loadChildren: () => import('./skedi/skedi.routes').then(m => m.SKEDI_ROUTES)
  },
  {
    path: 'kratisi',
    canActivate: [AdminGuard],
    loadChildren: () => import('./kratisi/kratisi.routes').then(m => m.KRATISI_ROUTES)
  },

  // ─── CMS / Site builder ───────────────────────────────────────────────────
  {
    path: 'cms',
    canActivate: [AdminGuard, permissionGuard],
    data: { permissions: [PERM.accessMoni], permissionMode: 'any' },
    loadComponent: () => import('./cms/features/admin-shell/admin-shell').then(m => m.AdminShell),
    children: [
      { path: '', redirectTo: 'pages', pathMatch: 'full' },
      { path: 'pages',      loadComponent: () => import('./cms/features/pages/pages-list/pages-list').then(m => m.PagesList) },
      { path: 'pages/new',  loadComponent: () => import('./cms/features/pages/page-form/page-form').then(m => m.PageForm) },
      { path: 'pages/:uuid', loadComponent: () => import('./cms/features/pages/page-form/page-form').then(m => m.PageForm) },
      { path: 'menus',       loadComponent: () => import('./cms/features/menus/menus-list/menus-list').then(m => m.MenusList) },
      { path: 'menus/:uuid', loadComponent: () => import('./cms/features/menus/menu-editor/menu-editor').then(m => m.MenuEditor) },
      { path: 'posts',      loadComponent: () => import('./cms/features/posts/posts-list/posts-list').then(m => m.PostsList) },
      { path: 'posts/new',  loadComponent: () => import('./cms/features/posts/post-form/post-form').then(m => m.PostForm) },
      { path: 'posts/:uuid', loadComponent: () => import('./cms/features/posts/post-form/post-form').then(m => m.PostForm) },
      { path: 'catalog',    loadComponent: () => import('./cms/features/catalog/catalog').then(m => m.Catalog) },
      { path: 'forms',      loadComponent: () => import('./cms/features/forms-manager/forms-manager').then(m => m.FormsManager) },
      { path: 'site',       loadComponent: () => import('./cms/features/site-settings/site-settings').then(m => m.SiteSettings) },
    ]
  },
  {
    path: 'cms/pages/:pageUuid/builder',
    canActivate: [AdminGuard, permissionGuard],
    data: { permissions: [PERM.accessMoni], permissionMode: 'any' },
    loadComponent: () => import('./cms/features/builder-editor/pages/builder-editor-page/builder-editor-page').then(m => m.BuilderEditorPage),
  },

  {
    path: '**',
    loadComponent: () => import('./cms/features/fo-page/fo-page').then(m => m.FoPage),
  }
];
